const { Core, Events, onBlazeLoad } = Global;

customElements.define('product-gallery-slider', class extends Core {
    propTypes = {
        'listen-variants': Boolean
    }
    
    elements = {
        slider: 'slideshow-blaze'
    }

    render() {
        if (this.prop('listen-variants')) {
            this.sub(Events.VARIANT_UPDATE, this._onVariantChange);
        }
        this.sub(Events.PRODUCT_GALLERY_SLIDE_CHANGE, this._changeSlide);
        onBlazeLoad(this._handleSlider.bind(this));
    }

    _onVariantChange({ imageIndex }) {

        if( typeof MagicZoom != 'undefined') {

            setTimeout(() => {
                

            var $id = mtGetParameterByName('variant');

            console.warn($id)

            if (typeof currentVariantID == 'undefined' || $id == currentVariantID) return;
            currentVariantID = $id;

            var $s = jQuery('a[data-variants*="' + $id + '"]');
            if (typeof MagicZoom != 'undefined' && $s.length) {
                MagicZoom.update(
                    $s.closest('.MagicToolboxContainer').find('.MagicZoomPlus').attr('id'),
                    $s.attr('href'),
                    $s.attr('data-image')
                )
            }

            }, 500);
        }

        if(imageIndex >= 0) {
            this.pub(Events.PRODUCT_GALLERY_SLIDE_CHANGE, imageIndex);
            this._changeSlide(imageIndex);
        }
    }

    async _handleSlider() {
        await customElements.whenDefined(this.elements.slider);
        this.$('slider').slider.onSlide(this._handleSlideChange.bind(this))
    }

    _handleSlideChange(index) {
        this.pub(Events.PRODUCT_GALLERY_SLIDE_CHANGE, index);
    }

    _changeSlide(index) {
        this.$('slider')?.slideTo(index);
    }
});